const FULL_TURN = Math.PI * 2;

function normalizedAngleDelta(current, previous) {
  let delta = current - previous;
  while (delta > Math.PI) delta -= FULL_TURN;
  while (delta < -Math.PI) delta += FULL_TURN;
  return delta;
}

/**
 * 检测鼠标是否在目标周围快速、连续且同方向地绕圈。
 * 返回 true 仅代表本次轨迹刚达到触发阈值。
 */
export function createPointerOrbitDetector(options = {}) {
  const config = {
    maxDurationMs: 1_400,
    maxSampleGapMs: 180,
    minRadius: 46,
    maxRadius: 430,
    minTurns: 0.9,
    minDirectionConsistency: 0.76,
    minPathLength: 460,
    ...options,
  };
  let previous = null;
  let startedAt = 0;
  let signedAngle = 0;
  let absoluteAngle = 0;
  let pathLength = 0;

  function reset() {
    previous = null;
    startedAt = 0;
    signedAngle = 0;
    absoluteAngle = 0;
    pathLength = 0;
  }

  function start(point, angle, time) {
    previous = { ...point, angle, time };
    startedAt = time;
  }

  function push(point, center, time = performance.now()) {
    const dx = point.x - center.x;
    const dy = point.y - center.y;
    const radius = Math.hypot(dx, dy);
    const angle = Math.atan2(dy, dx);

    if (radius < config.minRadius || radius > config.maxRadius) {
      reset();
      return false;
    }
    if (!previous) {
      start(point, angle, time);
      return false;
    }

    const gap = time - previous.time;
    if (gap <= 0 || gap > config.maxSampleGapMs || time - startedAt > config.maxDurationMs) {
      reset();
      start(point, angle, time);
      return false;
    }

    const delta = normalizedAngleDelta(angle, previous.angle);
    signedAngle += delta;
    absoluteAngle += Math.abs(delta);
    pathLength += Math.hypot(point.x - previous.x, point.y - previous.y);
    previous = { ...point, angle, time };

    const directionConsistency = absoluteAngle
      ? Math.abs(signedAngle) / absoluteAngle
      : 0;
    const triggered = Math.abs(signedAngle) >= FULL_TURN * config.minTurns
      && directionConsistency >= config.minDirectionConsistency
      && pathLength >= config.minPathLength;
    if (triggered) reset();
    return triggered;
  }

  return { push, reset };
}

